export default "__VITE_ASSET__0fc88015__"